var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"request"},[_c('iframe',{staticStyle:{"width":"100%","min-height":"850px","border":"0"},attrs:{"src":"https://broadcaster.cloudsdaleradio.com/public/cloudsdale_radio/embed-requests?theme=light","frameborder":"0","allowtransparency":"true"}})])
}]

export { render, staticRenderFns }